export class ValidationRule {
  startsWith: string | null = null;
  minLength: number | null = null;
  maxLength: number | null = null;
  exactLength: number | null = null;
  isAlfaNumeric: boolean | null = null;
  propertyType: number | null = null;
  numberofLetters:number | null = null;
  regExp!: string | null;
}

